var $a6a1af5968159b55$exports = {};
$a6a1af5968159b55$exports = {
    "breadcrumbs": `\u{130}\xe7erik haritalar\u{131}`
};


export {$a6a1af5968159b55$exports as default};
//# sourceMappingURL=tr-TR.mjs.map
